import SidenavUserData from "../types/SidenavUserData"

const SideNaveUserInfo = ( { sideNavUserColor:bg ,sideNavUserTextColor:text ,...props }:Props ) => {

  return (
    <div className={`h-16 ${bg ? bg:'bg-gray-800'} flex items-center justify-start px-4 ${text? text : 'text-white'} `}
    >
      {
        props.avatarUrl &&
          <div className="h-12 w-12 flex items-center rounded-full overflow-hidden mr-3">
            <img src={ props.avatarUrl } alt='' className="object-cover w-full h-full" />
          </div>
      }
      <div className="flex-1">
        <div className={``}>{props.name.substring( 0, 20 )}</div>
        <div className="flex w-full">
            {
            props.viewPerfilCallback &&
                <div className={`cursor-pointer text-primary mr-auto `} onClick={ props.viewPerfilCallback } > Ver perfil </div>
            }
            {
            props.logout &&
                <div className="hover:underline cursor-pointer text-primary" onClick={ props.logout } > Sair </div>
            }
        </div>
      </div>
    </div>
  )
}

interface Props extends SidenavUserData {
    sideNavUserColor?:string
    sideNavUserTextColor?:string
}
export default  SideNaveUserInfo
